import helpers from '../../../globals/helpers'

export default {
  minSoc: (state) => state.minSoc,
  maxSoc: (state) => state.maxSoc,

  totalNetCapacity: (state) => {
    if (state.totalGrossCapacityWh === 0) return 0
    return Math.round((state.totalNetCapacityWh * 100.0) / state.totalGrossCapacityWh)
  },

  configurableCapacity: (state, getters) =>
    getters.totalNetCapacity - getters.systemReserveCapacity,

  totalAvailableBackupCapacity: (state, getters) => {
    if (state.totalGrossCapacityWh === 0 || !getters.supportsOperatingMode('BACKUP_ENERGY')) return 0
    return Math.round(state.totalAvailableBackupCapacityWh * 100.0 / state.totalGrossCapacityWh)
  },

  feedInOptCapacity: (state, getters) => 
    getters.supportsOperatingMode('FEED_IN_OPT') ? Math.round(state.maxSoc - state.minSocFeedInOpt) : 0,

  selfConsumptionOptCapacity: (state) => {
    const upper = state.minSocFeedInOpt ?? state.maxSoc
    return Math.round(upper - state.minSocSelfConsumptionOpt)
  },

  peakShavingOptCapacity: (state, getters) => 
    getters.supportsOperatingMode('PEAK_SHAVING_OPT') ? Math.round(state.minSocSelfConsumptionOpt - state.minSocPeakShavingOpt) : 0,

  backupCapacity: (state, getters) => 
    getters.supportsOperatingMode('BACKUP_ENERGY') ? Math.round(state.minSocPeakShavingOpt - state.minSoc) : 0,

  systemReserveCapacity: (state) => 
    state.minSoc - state.depthOfDischargeCapacity,

  absoluteCapacity: (state, getters) => (type) => {
    let capacity = 0.0
    if (type === 'FEED_IN_OPT') capacity = getters.feedInOptCapacity
    else if (type === 'SELF_CONSUMPTION_OPT') capacity = getters.selfConsumptionOptCapacity
    else if (type === 'PEAK_SHAVING_OPT') capacity = getters.peakShavingOptCapacity
    else if (type === 'BACKUP_ENERGY') capacity = getters.backupCapacity 
    else if (type === 'SYSTEM_RESERVE') capacity = getters.systemReserveCapacity 
    else if (type === 'DEPTH_OF_DISCHARGE') capacity = state.depthOfDischargeCapacity
   
    const capacityWh = (capacity * state.totalGrossCapacityWh / 100.0).toFixed(1)
    return helpers.formatValueWithUnit(capacityWh, 'Wh')
   },

  maxGridPowerFeedInOptKW: (state) => {
    if (state.maxGridPowerFeedInOpt === null) return null
    return helpers.convertToUnit(state.maxGridPowerFeedInOpt).from('W').to('kW')
  },

  maxGridPowerPeakShavingOptKW: (state) => {
    if (state.maxGridPowerPeakShavingOpt === null) return null
    return helpers.convertToUnit(state.maxGridPowerPeakShavingOpt).from('W').to('kW')
  },

  supportsOperatingMode: (state) => (mode) => {
    return state.supportedOperatingModes.includes(mode)
  },

  operatingModeEnabled: (state) => (mode) => {
    return state.enabledOperatingModes.includes(mode)
  },

  currentFeedInOptCapacity: (state) => {
    if (state.currentMinSocFeedInOpt == null) return null
    return Math.round(state.maxSoc - state.currentMinSocFeedInOpt)
  },

  currentSelfConsumptionOptCapacity: (state) => {
    const upper = state.currentMinSocFeedInOpt ?? state.maxSoc
    if (state.currentMinSocSelfConsumptionOpt == null) return null
    return Math.round(upper - state.currentMinSocSelfConsumptionOpt)
  },

  currentPeakShavingOptCapacity: (state) => {
    const upper = state.currentMinSocSelfConsumptionOpt
    if (state.currentMinSocPeakShavingOpt == null || upper == null) return null
    return Math.round(upper - state.currentMinSocPeakShavingOpt)
  },

  currentBackupCapacity: (state) => {
    const upper = state.currentMinSocPeakShavingOpt ?? state.currentMinSocSelfConsumptionOpt
    if (upper == null) return null
    return Math.round(upper - (state.currentMinSoc ?? state.minSoc))
  },

  currentMaxGridPowerFeedInOptKW: (state) => {
    if (state.currentMaxGridPowerFeedInOpt == null) return null
    return helpers.convertToUnit(parseFloat(state.currentMaxGridPowerFeedInOpt)).from('W').to('kW')
  },

  currentMaxGridPowerPeakShavingOptKW: (state) => {
    if (state.currentMaxGridPowerPeakShavingOpt == null) return null
    return helpers.convertToUnit(parseFloat(state.currentMaxGridPowerPeakShavingOpt)).from('W').to('kW')
  },

  dataPoints: (state) => {
    const minSoc = helpers.numberWithPrecision(state.minSoc)
    const maxSoc = helpers.numberWithPrecision(state.maxSoc)
    const minSocFeedInOpt = helpers.numberWithPrecision(state.minSocFeedInOpt)
    const minSocSelfConsumptionOpt = helpers.numberWithPrecision(state.minSocSelfConsumptionOpt)
    const minSocPeakShavingOpt = helpers.numberWithPrecision(state.minSocPeakShavingOpt)

    return {
      MIN_SOC: {
        editable: minSoc,
      },
      MAX_SOC: {
        editable: maxSoc,
      },
      MIN_SOC_FEED_IN_OPT: {
        editable: minSocFeedInOpt,
      },
      MIN_SOC_SELF_CONSUMPTION_OPT: {
        editable: minSocSelfConsumptionOpt,
      },
      MIN_SOC_PEAK_SHAVING_OPT: {
        editable: minSocPeakShavingOpt,
      },
      MAX_GRID_POWER_FEED_IN_OPT: {
        editable: state.maxGridPowerFeedInOpt,
      },
      MAX_GRID_POWER_PEAK_SHAVING: {
        editable: state.maxGridPowerPeakShavingOpt,
      },
    }
  }
}
